import PurchaseOrdersNeedsFollowUpContainer from "./PurchaseOrdersNeedsFollowUpContainer";
export default PurchaseOrdersNeedsFollowUpContainer;
